import { SxProps, Theme } from '@mui/material';

export const sloganContactBoxIconsGridStylesSx: SxProps<Theme> = (theme) => ({
	display: 'flex',
	alignItems: 'center',
	[theme.breakpoints.up('md')]: {
		justifyContent: 'left',
	},
	[theme.breakpoints.down('md')]: {
		justifyContent: 'center',
		padding: '10px 0',
		borderBottom: '1px solid #eee',
	},
});
